import { Component, Input, inject } from '@angular/core';

import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
	selector: 'restart-webcast-source-dialog',
	templateUrl: './RestartWebcastSourceDialog.Component.html',
	standalone: false
})
export class RestartWebcastSourceDialogComponent {
	@Input() public initiateRestartSource: (msg?: string) => void;

	private readonly bsModalRef: BsModalRef = inject(BsModalRef);

	public audienceMessage: string;

	public close(): void {
		this.bsModalRef.hide();
	}

	public restartSource(): void {
		this.initiateRestartSource(this.audienceMessage);
		this.bsModalRef.hide();
	}
}
